
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","aria-label":"Sub Voce","viewBox":"0 0 22 11.59"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.48.61A10.18 10.18 0 018.85.16l.23.14a20 20 0 01-1 3l-.42.19a14.24 14.24 0 01-.43-2 2 2 0 00-3.32 1.18 1.71 1.71 0 00.71 1.42c.52.44 1.16.94 2 1.69a3.07 3.07 0 011.37 2.5c0 2-1.78 3.29-4.19 3.29a6.13 6.13 0 01-3.82-1.33 13.39 13.39 0 011.25-2.89l.32.05c.15.57.26 2 .48 3a3.4 3.4 0 001.44.28c1.4 0 2.2-.75 2.2-1.74a2 2 0 00-.85-1.53c-.58-.49-1.2-1-1.8-1.57A3.25 3.25 0 015.42.06a3 3 0 012.06.55zM10.44.26h4.34l-.28.71-.69.45c.05.55.14 1.72.71 7.11 1.06-1.59 3-4.56 4.52-7.13l-.82-.47.25-.67h3.48l-.2.67c-1.16.45-1.32.55-1.56.87-1 1.27-4.54 6.6-6 8.75a6.12 6.12 0 01-1.32 1h-.35c-.12-1-.6-5.28-1.13-9.77-.07-.45-.17-.55-1.32-.89z"}})])
          )
        }
      }
    